import _ from "lodash";
import { readConfigurationFragmentV2 } from "ChildrenPage/modules/ChildrenPageGraphqlHelpers";
import { parseConfigurationValue } from "Utils";
import ACLStore from "lib/aclStore";
import { AI_TRANSLATION_LANGUAGES } from "@toddle-edu/common-utils";

export const formalityFieldOptions = ({ t }) => {
  return [
    {
      key: "Formal",
      label: t("common:formal"),
    },
    {
      key: "Informal",
      label: t("common:informal"),
    },
  ];
};

export const defaultAIVoiceObj = {
  formality: "Formal",
  tone: ["Positive", "Confident", "Encouraging"],
  language: "British English",
};

export const toneOfVoiceFieldOptions = ({ t }) => {
  return [
    {
      key: "Excited",
      label: `😁 ${t("common:excited")}`,
    },
    {
      key: "Positive",
      label: `😇 ${t("common:positive")}`,
    },
    {
      key: "Witty",
      label: `😏 ${t("common:witty")}`,
    },
    {
      key: "Serious",
      label: `🤵‍♀️ ${t("common:serious")}`,
    },
    {
      key: "Firm",
      label: `👩‍⚖️ ${t("common:firm")}`,
    },
    {
      key: "Encouraging",
      label: `👩‍🏫 ${t("common:encouraging")}`,
    },
    {
      key: "Straightforward",
      label: `🙂 ${t("common:straightforward")}`,
    },
    {
      key: "Confident",
      label: `😌 ${t("common:confident")}`,
    },
  ];
};

export const preferredLanguageFieldOptions = params => {
  const {
    t = () => {},
    globalVoiceLanguages = [],
    showAllGlobalVoiceLanguages = false,
  } = params;

  if (showAllGlobalVoiceLanguages) {
    if (isUserPreferredAIVoiceLanguageModuleWiseEnabled()) {
      const sortedLanguages = _.sortBy(AI_TRANSLATION_LANGUAGES, "label");
      return _.map(sortedLanguages, language => {
        const { id, label, code } = language;
        return {
          key: _.toString(id),
          label,
          lng: code,
          value: code,
        };
      });
    } else {
      return _.map(globalVoiceLanguages, language => {
        const { id, name, locale } = language;
        return {
          key: id,
          label: name,
          lng: locale,
          value: locale,
        };
      });
    }
  }

  return [
    {
      key: "British English",
      lng: "en",
      name: "English (British)",
      label: t("common:british_english"),
    },
    {
      key: "American English",
      lng: "en",
      name: "English (American)",
      label: t("common:american_english"),
    },
    {
      key: "Spanish",
      lng: "es",
      name: "Spanish",
      label: t("common:spanish"),
    },
    {
      key: "Mandarin",
      lng: "zh",
      name: "Mandarin",
      label: t("common:chinese"),
    },
    {
      key: "Turkish",
      lng: "tr",
      name: "Turkish",
      label: t("common:turkish"),
    },
    {
      key: "French",
      lng: "fr",
      name: "French",
      label: t("common:french"),
    },
  ];
};

export const getEntityTypeBasedConfigurationValue = ({
  entityId,
  entityType,
  configurationName = "ConfigureAIVoiceLanguage",
}) => {
  const configuration = readConfigurationFragmentV2(
    {
      configurationEntityGroupFilters: [
        {
          configurationEntityGroups: [
            {
              entityId,
              entityType,
            },
          ],
        },
      ],
      isAdminPage: false,
      isSettingsPage: false,
      portalType: "SETTING",
    },
    configurationName
  );

  // parseConfigurationValue uses JSON.parse for TEXT which leads to error
  if (
    configurationName !== "ConfigureAIVoice" &&
    _.get(configuration, "valueType") === "TEXT"
  ) {
    return _.get(configuration, "value");
  }

  return parseConfigurationValue(configuration);
};

export const getConfigurationEntityGroupFilters = ({ gradeId, userId }) => {
  return [
    ...(gradeId
      ? [
          {
            configurationEntityGroups: [
              {
                entityId: gradeId,
                entityType: "GRADE",
              },
            ],
            configurationGroups: ["SETTING"],
          },
        ]
      : []),
    {
      configurationEntityGroups: [
        {
          entityId: userId,
          entityType: "USER",
        },
      ],
      configurationGroups: ["SETTING"],
    },
  ];
};

export const isUserPreferredAIVoiceLanguageModuleWiseEnabled = () => {
  return ACLStore.can(
    "FeatureFlag:UserPreferredAIVoiceLanguageModuleWiseEnabled"
  );
};
